import React from "react";

/** Card "Obra Selecionada" mostrado no topo dos submenus da obra. */
export default function ProjectContextCard({ projectName }: { projectName: string }) {
    return (
        <div className="mx-4 mb-4 p-3 bg-white/5 dark:bg-night_surface/5 border border-white/5 rounded-lg animate-in fade-in zoom-in duration-slow">
            <p className="text-[10px] text-white/70 uppercase font-bold tracking-tight mb-1">Obra Selecionada</p>
            <p className="text-sm font-medium text-white/80 truncate" title={projectName}>
                {projectName || "Carregando..."}
            </p>
        </div>
    );
}
